import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HelpCenterService } from './help-center.service';

@Component({
  selector: 'lib-help-center',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.scss'],
})
export class HelpCenterComponent {
  readonly helpService = inject(HelpCenterService);

  /** Trata clique fora no backdrop para fechar no desktop */
  onOverlayClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('n-help-overlay')) {
      this.helpService.closeHelp();
    }
  }

  /** Atualiza o termo de busca no service */
  onSearchInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.helpService.setSearchQuery(input.value);
  }
}
